jQuery(document).ready(function() {

  $(".fs-ingredients").slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        autoplay: 0,
        slidesToScroll: 1,
        adaptiveHeight: !0,
        infinite: false,
        responsive: [
            { breakpoint: 1024, settings: { adaptiveHeight: !0, slidesToShow: 4 } },
            { breakpoint: 480, settings: { adaptiveHeight: !0, slidesToShow: 1,slidesToScroll: 1 } },
        ],
  });

  $(".featuredin_slider_old").slick({
    speed: 3000,
	autoplay: true,
	autoplaySpeed: 0,
	cssEase: 'linear',
    slidesToShow: 6,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
       ]
  });

  $('.featuredin_slider_new').slick(
      {
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1,
          speed: 2500,
          dots: false,
          cssEase: 'linear',
          waitForAnimate: false,
          pauseOnFocus: false, 
          pauseOnHover: false,
          responsive: [
          {
              breakpoint: 1024,
              settings:
              {
                  slidesToShow: 4,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 769,
              settings:
              {
                  slidesToShow:3,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 480,
              settings:
              {
                  slidesToShow:2,
                  slidesToScroll: 1
              }
          }, 
        ],
  });




});